import { render, staticRenderFns } from "./LessonGroupSetting.vue?vue&type=template&id=db9414de&scoped=true&lang=pug&"
import script from "./LessonGroupSetting.vue?vue&type=script&lang=ts&"
export * from "./LessonGroupSetting.vue?vue&type=script&lang=ts&"
import style0 from "./LessonGroupSetting.vue?vue&type=style&index=0&id=db9414de&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9414de",
  null
  
)

export default component.exports